import { JobApplication, JobApplicationStatus } from '../generated/gql-types';
import {
  GET_JOB_APPLICATIONS_FOR_JOB,
  GET_JOB_APPLICATIONS_FOR_USER,
  GET_JOB_APPLICATIONS_FOR_CLIENT,
  RESPOND_TO_APPLICATION,
} from './jobApplication.gql';
import { getApolloClient } from '../lib/getApolloClient';
import { handleGraphQLErrors } from '../util/graphqlError.util';
import type { AssignmentRateOverrides } from '../job/assignmentRateOverrides.type';

const fetchJobApplicationsForUser = async (
  userId: string,
): Promise<JobApplication[]> => {
  const { data, errors } = await getApolloClient().query({
    query: GET_JOB_APPLICATIONS_FOR_USER,
    variables: { userId },
  });

  handleGraphQLErrors(errors);

  if (data?.getJobApplicationsForUser) {
    return data.getJobApplicationsForUser;
  }

  return [];
};

const fetchJobApplicationsForJob = async (jobId: string) => {
  const { data } = await getApolloClient().query({
    query: GET_JOB_APPLICATIONS_FOR_JOB,
    variables: { jobId },
  });
  return data.getJobApplicationsForJob;
};

const fetchJobApplicationsForClient = async (clientId: string) => {
  const { data } = await getApolloClient().query({
    query: GET_JOB_APPLICATIONS_FOR_CLIENT,
    variables: { clientId },
  });
  return data.getJobApplicationsForClient;
};

const respondToApplication = async (
  jobApplicationId: string,
  itemStatus: JobApplicationStatus,
  rateOverrides?: AssignmentRateOverrides,
): Promise<boolean | null> => {
  const { data, errors } = await getApolloClient().mutate({
    mutation: RESPOND_TO_APPLICATION,
    variables: {
      id: jobApplicationId,
      status: itemStatus,
      ...rateOverrides,
    },
  });
  handleGraphQLErrors(errors);
  return data?.respondToApplication ?? null;
};

export const jobApplicationActions = {
  fetchJobApplicationsForUser,
  fetchJobApplicationsForJob,
  respondToApplication,
  fetchJobApplicationsForClient,
};
